/** Native buttons must not remain actionable while an async action is pending. */
export function isButtonDisabled(disabled: boolean, loading: boolean): boolean {
	return disabled || loading;
}
